module.exports = __webpack_public_path__ + "static/visa-deals-bg-desktop-589dc2b6c7dc4f7bd7eae30fea4f2699.jpg";